import { getEffectsData, getRanges, getNamedEffect } from './common';
function getAnimationTarget(target, part) {
  return target ? `#${target}${part ? `[data-motion-part~="${part}"]` : ''}` : '';
}
function getAnimationAsCSS(data, isRunning) {
  const {
    duration,
    delay,
    iterations = 1,
    fill,
    easing = 'linear',
    direction
  } = data.options;
  const animationName = data.effect.name;
  const isAutoDuration = duration === 'auto';
  return `${animationName} ${isAutoDuration ? 'auto' : `${duration}ms`}${isAutoDuration ? ' ' : ` ${delay || 1}ms `}${easing}${fill && fill !== 'none' ? ` ${fill}` : ''} ${!iterations || iterations === Infinity ? 'infinite' : iterations}${direction === 'normal' ? '' : ` ${direction}`} ${isRunning ? '' : 'paused'}`;
}
function getCSSAnimationEffect(preset, animation) {
  if (preset != null && preset.style) {
    // validate duration is a number over 0
    if (animation.type === 'TimeAnimationOptions') {
      animation.duration = animation.duration || 1;
    }
    return preset.style(animation);
  }
  return [];
}
function getCSSAnimation(target, animationOptions, trigger) {
  // get the preset for the given animation options
  const namedEffect = getNamedEffect(animationOptions);
  const animationsData = getCSSAnimationEffect(namedEffect, animationOptions);
  const data = getEffectsData(animationsData, animationOptions.effectId);
  const isViewProgress = (trigger == null ? void 0 : trigger.trigger) === 'view-progress';
  return data.map((item, index) => {
    const {
      start,
      end
    } = isViewProgress ? getRanges(item.effect) : {};
    return {
      target: getAnimationTarget(target, item.part),
      animation: getAnimationAsCSS(item, isViewProgress),
      composition: item.options.composite,
      custom: item.effect.custom,
      name: item.effect.name,
      keyframes: item.effect.keyframes,
      id: item.id && `${item.id}-${index + 1}`,
      animationTimeline: isViewProgress ? `--${trigger == null ? void 0 : trigger.id}` : '',
      animationRange: start || end ? `${start} ${end}` : ''
    };
  });
}
export { getCSSAnimation, getCSSAnimationEffect, getAnimationAsCSS };
//# sourceMappingURL=cssAnimations.js.map